"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const lucide_vue_next_1 = require("lucide-vue-next");
let AssignmentMetadata = class AssignmentMetadata extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.filesSummaryStep;
        this.farmNameMetadataColumn = null;
        this.fieldNameMetadataColumn = null;
        this.showAlertMetadata = false;
    }
    get targetMetadataNames() {
        return ['fieldName', 'farmName'];
    }
    get fileColumns() {
        var _a;
        return (_a = this.currentFile.metadata) === null || _a === void 0 ? void 0 : _a.map(meta => meta.columnName);
    }
    setFarmNameMetadataColumn(fileMetadataColumn) {
        this.farmNameMetadataColumn = fileMetadataColumn;
        this.currentFile.farmMetadata = fileMetadataColumn;
        this.currentFile.assignmentFarmNameCompleted = false;
    }
    setFieldNameMetadataColumn(fileMetadataColumn) {
        this.fieldNameMetadataColumn = fileMetadataColumn;
        this.currentFile.fieldMetadata = fileMetadataColumn;
        this.currentFile.assignmentFieldNameCompleted = false;
    }
    metadataFileExample(columnFileName) {
        const meta = this.currentFile.metadata.find(meta => columnFileName === meta.columnName);
        return meta === null || meta === void 0 ? void 0 : meta.columnValue;
    }
    assignmentFieldNameValues() {
        this.showAlertMetadata = true;
        this.STEP_CONTROLLER.setMetadataField(this.currentFile.name, this.fieldNameMetadataColumn, 'FieldName');
        this.currentFile.assignmentFieldNameCompleted = true;
        setTimeout(() => {
            this.showAlertMetadata = false;
        }, 2500);
    }
    assignmentFarmNameValues() {
        this.showAlertMetadata = true;
        this.STEP_CONTROLLER.setMetadataField(this.currentFile.name, this.farmNameMetadataColumn, 'FarmName');
        this.currentFile.assignmentFarmNameCompleted = true;
        setTimeout(() => {
            this.showAlertMetadata = false;
        }, 2500);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], AssignmentMetadata.prototype, "currentFile", void 0);
AssignmentMetadata = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Select: bmk_ui_framework_1.Select, Button: bmk_ui_framework_1.Button, ArrowRight: lucide_vue_next_1.ArrowRight, Equal: lucide_vue_next_1.Equal, CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon, Tag: bmk_ui_framework_1.Tag, XRoundedIcon: bmk_ui_framework_1.XRoundedIcon, CheckCircle: lucide_vue_next_1.CheckCircle }
    })
], AssignmentMetadata);
exports.default = AssignmentMetadata;
